import { Modal } from "react-bootstrap";
import GradientButton from "../GradientButton";

export default function AgentAlreadyAssignedModal(props) {
	return (
		<Modal show={props.show} onHide={props.onOKClicked}>
			<Modal.Header>
				<h3>Agent Already Assigned</h3>
			</Modal.Header>
			<Modal.Body>
				<p className="mb-0">A sales agent has already been assigned to this address.</p>
			</Modal.Body>
			<Modal.Footer>
				<GradientButton title="OK" variant="greenYellow" onClick={props.onOKClicked} />
			</Modal.Footer>
		</Modal>
	);
}
